import React, { FC } from 'react';
import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import AuthorizedLayout from '../../shared/layout/AuthorizedLayout';
import { useStyles } from './styles';
import MentorList from './mentor-list';
import { DropdownFilters, NoResults, TopicFilter } from '../../shared/filters';

import useMentorPageFilters from './use-mentor-page-filters';
import MentorsPageHeader from './mentors-page-header';
import MentorsPageNavigation from './mentors-page-navigation';

const MentorsPage: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const {
    handleChangeLanguage,
    handleChangeTopic,
    recommendedMentorsList,
    notRecommendedMentorsList,
    languageOptions,
    language,
    topic,
    availableTopics,
    handleReset,
    showReset,
    loading,
  } = useMentorPageFilters();

  return (
    <AuthorizedLayout>
      <Box className={classes.mainContainer}>
        <Box className={classes.contentContainer}>
          <MentorsPageNavigation />

          <Box className={classes.mentorsListWrapper}>
            <MentorsPageHeader />
            <TopicFilter
              availableTopics={availableTopics}
              onChange={handleChangeTopic}
              topic={topic}
              allTopicsLabel={t('v2.global.tab_label_topic_allMentors')}
            />
            <DropdownFilters
              filters={[
                {
                  name: 'languageFilter',
                  value: language,
                  onChange: handleChangeLanguage,
                  options: languageOptions,
                },
              ]}
            />

            <MentorList
              loading={loading}
              showLotteryCard={topic === 0}
              recommendedMentorsList={recommendedMentorsList}
              notRecommendedMentorsList={notRecommendedMentorsList}
            />
            {showReset && <NoResults onReset={handleReset} />}
          </Box>
        </Box>
      </Box>
    </AuthorizedLayout>
  );
};

export default MentorsPage;
